<template>
  <div v-if="contact && contact.agreementNo">
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-main w-100" :style="`background-color:${color};color:white`">
      <h3 class="w-100 text-center my-3">ชำระเงิน</h3>
    </div>
    <div class="mb-2 flex-all-center session-with-nav">
      <div>
        <v-img
          v-if="sourceSelect && sourceSelect == 'nmny'"
          class="my-0 radius-circle"
          style="width:170px;height:auto"
          src="@/assets/logo_long_nm.png"
        ></v-img>
        <v-img
          v-else
          class="my-0 radius-circle"
          style="width:170px;height:auto"
          src="@/assets/logo_long.png"
        ></v-img>
      </div>
    </div>
    <div class="px-5">
      <div class="text-right text-gray fs-14">เลขที่สัญญา {{ contact.agreementNo }}</div>
      <v-card class="p-3 mt-3 rounded-7">
        <div class="" style="font-weight: bold;">ยอดรวมปัจจุบันที่ต้องชำระ</div>
        <div>
          <span class="text-blue" :style="`font-weight: bold;color: ${color} !important`">{{
            formatNumber(contact.paymentDue) || '0'
          }}</span>
          <span>บาท</span>
        </div>
      </v-card>
      <div class="mt-3 fs-14">
        <span class="text-gray">กำหนดชำระภายในวันที่ {{ setDate(contact.payDueDate) }}</span>
        <span style="color:red">{{
          contact.contractStatus == 'ล่าช้า' ? '(เกินกำหนดชำระ)' : ''
        }}</span>
      </div>
      <div class="fs-14">
        <span class="text-gray">เพื่อหลีกเลี่ยงค่าปรับค่าติดตาม กรุณาชำระภายในกำหนด</span>
      </div>
      <div class="mt-5">
        <div>กดเลือกแสดง คิวอาร์โค้ด หรือ บาร์โค้ด ตามช่องทางชำระเงิน เพื่อสแกน</div>
        <div class="mt-2">
          <div class="p-3 border" @click="typeGen = 'qr'" :class="{ select: typeGen == 'qr' }">
            <v-layout class="m-1" row :wrap="false">
              <div class="col-3">
                <v-img style="width:50px;height:auto" src="@/assets/qr_icon.svg"></v-img>
              </div>
              <v-layout class="col-9" column>
                <div class="text-blue fs-18" :style="`color: ${color} !important`">คิวอาร์โค้ด</div>
                <div class="text-gray fs-12">สำหรับชำระผ่านช่องทางธนาคาร</div>
              </v-layout>
            </v-layout>
          </div>
          <div
            class="p-3 mt-4 border"
            @click="typeGen = 'bar'"
            :class="{ select: typeGen == 'bar' }"
          >
            <v-layout class="m-1" row :wrap="false">
              <div class="col-3">
                <v-img style="width:50px;height:auto" src="@/assets/barcode_icon.svg"></v-img>
              </div>
              <v-layout class="col-9" column>
                <div class="text-blue fs-18" :style="`color: ${color} !important`">บาร์โค้ด</div>
                <div class="text-gray fs-12">
                  สำหรับชำระผ่านจุดรับชำระเงิน เช่น เคาน์เตอร์เซอร์วิส หรือเทสโก้โลตัส
                </div>
              </v-layout>
            </v-layout>
          </div>
        </div>
        <div class="my-5 w-100 flex-all-center">
          <v-btn
            @click="clickShow"
            :loading="loading"
            :disabled="!typeGen"
            large
            class="col-8 main-btn"
            style="color:white"
            :color="color"
            >แสดง QR หรือ Barcode</v-btn
          >
        </div>
      </div>
    </div>
    <v-dialog v-model="show" scrollable max-width="500px" transition="dialog-transition">
      <v-card v-if="typeGen == 'qr' && barCodeData" class="p-3">
        <div class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="text-center" style="margin-top:-25px">
          ยอดชำระ
          <span class="text-blue fs-18" :style="`color: ${color} !important`">{{
            formatNumber(contact.paymentDue)
          }}</span>
          บาท
        </div>
        <div class="flex-all-center">
          <VueQrcode ref="qrref" @ready="cBit($event)" :value="useAbleRefCode" :width="250" />
        </div>
        <v-img class="mr-2" :src="bit"></v-img>
        <div class=" text-center">
          <div class=" text-blue" :style="`color: ${color} !important`">
            แคปเจอร์หน้าจอเพื่อบันทึกภาพ
          </div>
          <div class="mb-4 mt-1 text-center">
            <span class="text-blue" :style="`color: ${color} !important`">ผู้เช่าซื้อ</span> :
            {{ barCodeData.prefix }}{{ barCodeData.firstName }} {{ barCodeData.lastName }}
          </div>
          <!-- <a v-if= "barCodeData.refCard" download="filename.jpeg" :href="barCodeData.refCard"> -->
          <!-- <v-btn @click="downloadQR" large class="px-7 main-btn my-3" style="color:white" color="#23409A">
            <span>
              <v-img class="mr-2" style="width:20px;height:auto" src="@/assets/dist.svg"></v-img>
            </span>
            บันทึกภาพ
          </v-btn> -->
          <!-- </a> -->
        </div>
      </v-card>
      <v-card
        v-else-if="typeGen == 'bar' && barCodeData && useAbleRefCode"
        class="p-3"
        style="height:90vh"
      >
        <div class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="text-center" style="margin-top:-25px">
          ยอดชำระ
          <span class="text-blue fs-18" :style="`color: ${color} !important`">{{
            formatNumber(contact.paymentDue)
          }}</span>
          บาท
        </div>
        <div
          style="width:0;heigth:0;transform: rotate(90deg);margin-left: 140px;margin-top: -45px;"
        >
          <VueBarcode
            ref="barref"
            :text="barCodeData.refCardDisplay"
            :value="useAbleRefCode"
            elementTag="img"
          />
        </div>
        <div class="bot-session text-center">
          <div class="text-blue" :style="`color: ${color} !important`">
            แคปเจอร์หน้าจอเพื่อบันทึกภาพ
          </div>
          <div class="mb-4 mt-1 text-center">
            <span class="text-blue" :style="`color: ${color} !important`">ผู้เช่าซื้อ</span> :
            {{ barCodeData.prefix }}{{ barCodeData.firstName }} {{ barCodeData.lastName }}
          </div>
          <!-- <a v-if="barCodeData.refCard" download="filename.jpeg" :href="barCodeData.refCard"> -->

          <!-- <v-btn @click="downloadBar" large class="px-7 main-btn my-3" style="color:white" color="#23409A"
            ><span><v-img class="mr-2" style="width:20px;height:auto" src="@/assets/dist.svg"></v-img></span> บันทึกภาพ
          </v-btn> -->
          <!-- </a> -->
        </div>
        <!-- <div ></div> -->
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <div class="navbar w-100" :style="`background-color:#${color};color:white`">
      <h3 class="w-100 text-center my-3">ชำระเงิน</h3>
    </div>
    <div class="text-center my-15 w-100">
      ไม่มีข้อมูลที่เลือกอยู่
    </div>
  </div>
</template>

<script>
import api from '@/api'
import contractApi from '@/api/contract'
import moment from 'moment'
import VueQrcode from 'vue-qrcode'
import VueBarcode from 'vue-barcode'
import config from '@/config'
// import { qrcode } from "https://deno.land/x/qrcode/mod.ts";
import VueElementLoading from 'vue-element-loading'
export default {
  components: { VueElementLoading, VueQrcode, VueBarcode },
  data() {
    return {
      loading: false,
      typeGen: '',
      show: false,
      barCodeData: null,
      bit: null,
      useAbleRefCode: null
    }
  },

  mounted() {
    this.setup()
  },
  methods: {
    async setup() {},
    setDate(input) {
      return moment(input).format('DD/MM/YYYY')
    },
    cBit(evt) {
      this.bit = evt
    },
    async clickShow() {
      if (this.sourceSelect && this.sourceSelect == 'nmny') {
        this.clickShowNmny()
        return
      }
      let type = this.typeGen
      this.loading = true
      if (!this.barCodeData) {
        let body = {
          page_id: config.pageid,
          id_card: this.userData.cardnumber || this.userData.idcard,
          agreement_no: this.contact.agreementNo,
          company: 'NCAP'
        }
        let res = await contractApi.genBarCode({ body })
        this.barCodeData = res?.data?.data
      }
      let split_data = this.barCodeData.refCard.substring(1)
      if (type == 'bar') {
        split_data = split_data.replace('|00|', '||')
        split_data = `${split_data.split('||')[0]}||00`
      }
      split_data = `|${split_data.replaceAll('|', '\n')}`
      this.useAbleRefCode = split_data
      this.loading = false
      this.show = true
    },
    async clickShowNmny() {
      let type = this.typeGen
      this.loading = true
      if (!this.barCodeData) {
        let body = {
          page_id: config.pageid,
          id_card: this.userData.cardnumber || this.userData.idcard,
          agreement_no: this.contact.agreementNo,
          company: 'NMNY'
        }
        let res = await contractApi.genBarCode({ body })
        this.barCodeData = res?.data?.data
      }
      let split_data = this.barCodeData.refCard.substring(1)
      split_data = `|${split_data.replaceAll('|', '\n')}`
      this.useAbleRefCode = split_data
      this.loading = false
      this.show = true
    },
    async downloadQR() {
      if (await window.liff.isInClient()) {
        try {
          // await window.liff.sendMessages([
          //   {
          //     originalContentUrl: `${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`,
          //     previewImageUrl: `${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`,
          //     type: "image",
          //   },
          // ]);
          await liff.openWindow({
            url: `${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`,
            external: true
          })
        } catch (error) {
          alert(JSON.stringify(error))
          alert(JSON.stringify(error.message))
        }
      } else {
        window.open(`${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`)
        // var url = this.$store.state.serverUrl + "zwiz-pushmsg-webbrowser";
        // axios.post(
        //   url,
        //   {
        //     originalContentUrl: `${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`,
        //     previewImageUrl: `${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`,
        //     type: "image",
        //   },
        //   {
        //     headers: {
        //       AUTHORIZATION: "Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc",
        //     },
        //   }
        // );
        if (this.useridWithPage.match('__')) {
          let img = this.$refs.qrref.$el.src
          var link = document.createElement('a')
          link.download = 'QR.png'
          link.href = img
          document.body.appendChild(link)
          link.click()
        } else {
          this.$store.dispatch(
            'sendMessage',
            `BarCodeORQrCodeNextCapital ${config.COMMU}/nextcapital/urlqr?type=${this.barCodeData.refCard}`
          )
        }
      }
    },
    async downloadBar() {
      //   console.log("downloadQR", this.$refs.barref.$el.getElementsByClassName("vue-barcode-element")[0].src);
      if (await window.liff.isInClient()) {
        try {
          // await window.liff.sendMessages([
          //   {
          //     originalContentUrl: `${config.COMMU}/nextcapital/urlbar?type=${this.barCodeData.refCard}`,
          //     previewImageUrl: `${config.COMMU}/nextcapital/urlbar?type=${this.barCodeData.refCard}`,
          //     type: "image",
          //   },
          // ]);
          await liff.openWindow({
            url: `${config.COMMU}/nextcapital/urlbar?type=${this.barCodeData.refCard}`,
            external: true
          })
          // this.$store.dispatch("sendMessage",`${config.COMMU}/nextcapital/urlbar?type=${this.barCodeData.refCard}` );
        } catch (error) {
          alert(JSON.stringify(error))
          alert(JSON.stringify(error.message))
        }
      } else {
        window.open(`${config.COMMU}/nextcapital/urlbar?type=${this.barCodeData.refCard}`)
        // if (this.useridWithPage.match("__")) {
        //   let img = this.$refs.barref.$el.getElementsByClassName("vue-barcode-element")[0].src;
        //   var link = document.createElement("a");
        //   link.download = "QR.png";
        //   link.href = img;
        //   document.body.appendChild(link);
        //   link.click();
        // } else {
        //   this.$store.dispatch("sendMessage", `BarCodeORQrCodeNextCapital ${config.COMMU}/nextcapital/urlbar?type=${this.barCodeData.refCard}`);
        // }
      }
    },
    formatNumber(num) {
      if (num && num !== '-') {
        let temp_num = parseFloat(num).toFixed(2)
        let pattern = /\d{1,3}(?=(\d{3})+(?!\d))/g
        return temp_num.toString().replace(pattern, '$&,')
      } else {
        return 0
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.state.profile.userId
    },
    contact() {
      return this.$store.state.contactSelect
    },
    userData() {
      return this.$store.state.userData
    },
    useridWithPage() {
      return this.$store.state.userid
    },
    sourceSelect() {
      return this.$store.state.sourceSelect
    },
    color() {
      if (this.sourceSelect == 'nmny') {
        return '#007a47'
      }
      return '#23409a'
    }
  }
}
</script>

<style>
.select {
  background-color: #e8e8e8 !important;
  border: 1px solid #23409a !important;
  box-shadow: 0px 3px 1px -2px rgb(35 64 154 / 20%), 0px 2px 2px 0px rgb(35 64 154 / 14%),
    0px 1px 5px 0px rgb(35 64 154 / 12%) !important;
}
.vue-barcode-element {
  width: 68vh;
}
.bot-session {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
